import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class CaseNotesModel extends BaseModel {
  @attr("string") id;
  @attr("string") case;
  @attr("array") actionableItems;
  @attr("boolean") canEdit;
  @attr("string") content;
  @attr("boolean") internalOnly;
  @attr("boolean") pinned;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("json") createdBy;
  @attr("json") updatedBy;
  @attr("json") readOnly;
}
